module.exports = __webpack_public_path__ + "assets/img/175626359ebfde0806f8dd6cd72c9bce.png";